export default __webpack_public_path__ + "static/media/cash-money.cbea12f0.gif";